App.namespace.wrap('components.page_visibility_tracker', (IntersectionObserverInjected) => {
  const IntersectionObserver = IntersectionObserverInjected || window.IntersectionObserver;

  const THRESHOLD = 0.8;
  const OBSERVER_OPTIONS = {
    threshold: THRESHOLD,
  };

  const ROOMS_CLICKED = [];
  const ROOMS_DISPLAYED = [];
  const DISPLAYED_ROOM_NODES = [];

  let $observedElements;
  let observer;
  let api;
  let metadata = {};
  let roomSeenDurations = {};

  const startRoomCounter = (roomId) => {
    let roomWatch = roomSeenDurations[roomId];

    if (!roomWatch) {
      roomSeenDurations[roomId] = App.components.stop_watch();
      roomWatch = roomSeenDurations[roomId];
    }

    roomWatch.init();
    roomWatch.start();
  };

  const stopRoomCounter = (roomId) => {
    const roomWatch = roomSeenDurations[roomId];

    // if element was never seen, there is nothing to stop
    if (!roomWatch) {
      return;
    }
    roomWatch.stop();
  };

  const stopAllRoomCounters = () => {
    const roomIds = Object.keys(roomSeenDurations);

    roomIds.forEach(stopRoomCounter);
  };

  const observerCallback = (entries) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio < THRESHOLD) {
        stopRoomCounter($(entry.target).data('id'));
        return;
      }

      startRoomCounter($(entry.target).data('id'));

      // Add to list only if it's not there yet
      if (DISPLAYED_ROOM_NODES.indexOf(entry.target) >= 0) {
        return;
      }

      DISPLAYED_ROOM_NODES.push(entry.target);

      const roomId = $(entry.target).data('id');
      ROOMS_DISPLAYED.push(roomId);
    });
  };

  const resetClickedRooms = () => {
    ROOMS_CLICKED.splice(0, ROOMS_CLICKED.length);
  };

  const resetDisplayedRooms = () => {
    ROOMS_DISPLAYED.splice(0, ROOMS_DISPLAYED.length);
  };

  const resetCounters = () => {
    resetClickedRooms();
    resetDisplayedRooms();
  };

  const addRoomClicked = (id) => {
    if (ROOMS_CLICKED.indexOf(id) !== -1) {
      return;
    }
    ROOMS_CLICKED.push(id);
  };

  const addRoomDisplayed = (id) => {
    if (ROOMS_DISPLAYED.indexOf(id) !== -1) {
      return;
    }

    ROOMS_DISPLAYED.push(id);
  };

  const getClickedRooms = () => {
    return [...ROOMS_CLICKED];
  };

  const MINIMUM_DISPLAY_DURATION_MS = 2000;

  const getDisplayedRooms = () => {
    return ROOMS_DISPLAYED.filter(roomId => {
      if (!roomSeenDurations[roomId]) {
        return false;
      }
      roomSeenDurations[roomId].addPendingDurations();

      return roomSeenDurations[roomId].getTimes().duration >= MINIMUM_DISPLAY_DURATION_MS;
    });
  };

  const getDisplayedRoomsDurations = () => {
    return getDisplayedRooms().map(roomId => {
      if (!roomSeenDurations[roomId]) {
        return 0;
      }

      roomSeenDurations[roomId].addPendingDurations();

      return roomSeenDurations[roomId].getTimes().duration;
    });
  };

  const destroyObserver = () => {
    DISPLAYED_ROOM_NODES.splice(0, DISPLAYED_ROOM_NODES.length);
    observer.disconnect();
  };

  const disconnectObserver = () => {
    observer.disconnect();
  };

  const attachObserver = () => {
    if (!$observedElements) {
      return;
    }

    $observedElements.toArray().forEach((element) => {
      observer.observe(element);
    });
  };

  const observe = ($elements) => {
    $observedElements = $elements;
    if (App.components.page_visibility_api.isPageVisible()) {
      attachObserver();
    }
  };

  const getMetadata = () => {
    return metadata;
  };

  const setMetadata = (data) => {
    metadata = data;
  };

  const resetSeenDurations = () => {
    roomSeenDurations = {};
  };

  const clear = () => {
    destroyObserver();
    resetCounters();
    setMetadata({});
    resetSeenDurations();
  };

  const init = () => {
    if (!IntersectionObserver) {
      return null;
    }

    observer = new IntersectionObserver(observerCallback, OBSERVER_OPTIONS);

    window.__observer = observer;
    return api;
  };

  const onVisibilityChange = ({ visible }) => {
    if (!IntersectionObserver) {
      return;
    }

    if (visible) {
      attachObserver();
    } else {
      stopAllRoomCounters();
      disconnectObserver();
    }
  };

  App.components.page_visibility_api.init(onVisibilityChange);

  api = {
    init,
    clear,
    observe,
    resetCounters,
    addRoomClicked,
    addRoomDisplayed,
    getClickedRooms,
    getMetadata,
    setMetadata,
    getDisplayedRooms,
    getDisplayedRoomsDurations,
  };

  return api;
});
